// icon:bx-planet | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";
import Icon from "../../images/art/icons/Planet.png";

function IconBxPlanet(props) {
	return (
		<img src={Icon} style={{ height: '1em', width: '1em', ...props }} alt={"Planet"} />
	)
}

export default IconBxPlanet;
